var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _defs;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCalculatorIcon = function SvgCalculatorIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bi_2642_70811)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_2642_70811",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 2C4.44772 2 4 2.44772 4 3V21C4 21.5523 4.44772 22 5 22H19C19.5523 22 20 21.5523 20 21V3C20 2.44772 19.5523 2 19 2H5ZM18 4H6V8H18V4Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 2C4.44772 2 4 2.44772 4 3V21C4 21.5523 4.44772 22 5 22H19C19.5523 22 20 21.5523 20 21V3C20 2.44772 19.5523 2 19 2H5ZM18 4H6V8H18V4Z",
    fill: "#F1F1F1",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 2C4.44772 2 4 2.44772 4 3V21C4 21.5523 4.44772 22 5 22H19C19.5523 22 20 21.5523 20 21V3C20 2.44772 19.5523 2 19 2H5ZM18 4H6V8H18V4Z",
    fill: "url(#paint0_linear_2642_70811)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 4V3.8H5.8V4H6ZM18 4H18.2V3.8H18V4ZM6 8H5.8V8.2H6V8ZM18 8V8.2H18.2V8H18ZM4.2 3C4.2 2.55817 4.55817 2.2 5 2.2V1.8C4.33726 1.8 3.8 2.33726 3.8 3H4.2ZM4.2 21V3H3.8V21H4.2ZM5 21.8C4.55817 21.8 4.2 21.4418 4.2 21H3.8C3.8 21.6627 4.33726 22.2 5 22.2V21.8ZM19 21.8H5V22.2H19V21.8ZM19.8 21C19.8 21.4418 19.4418 21.8 19 21.8V22.2C19.6627 22.2 20.2 21.6627 20.2 21H19.8ZM19.8 3V21H20.2V3H19.8ZM19 2.2C19.4418 2.2 19.8 2.55817 19.8 3H20.2C20.2 2.33726 19.6627 1.8 19 1.8V2.2ZM5 2.2H19V1.8H5V2.2ZM6 4.2H18V3.8H6V4.2ZM6.2 8V4H5.8V8H6.2ZM18 7.8H6V8.2H18V7.8ZM17.8 4V8H18.2V4H17.8Z",
    fill: "url(#paint1_linear_2642_70811)",
    fillOpacity: 0.1,
    mask: "url(#path-2-inside-1_2642_70811)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bi_2642_70811)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 11,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#F1F1F1",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 11,
    width: 2,
    height: 2,
    rx: 1,
    fill: "url(#paint2_linear_2642_70811)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.16667,
    y: 11.1667,
    width: 1.66667,
    height: 1.66667,
    rx: 0.833333,
    stroke: "url(#paint3_linear_2642_70811)",
    strokeOpacity: 0.1,
    strokeWidth: 0.333333
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bi_2642_70811)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 14,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#F1F1F1",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 14,
    width: 2,
    height: 2,
    rx: 1,
    fill: "url(#paint4_linear_2642_70811)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.16667,
    y: 14.1667,
    width: 1.66667,
    height: 1.66667,
    rx: 0.833333,
    stroke: "url(#paint5_linear_2642_70811)",
    strokeOpacity: 0.1,
    strokeWidth: 0.333333
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_bi_2642_70811)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 14,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#F1F1F1",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 14,
    width: 2,
    height: 2,
    rx: 1,
    fill: "url(#paint6_linear_2642_70811)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.1667,
    y: 14.1667,
    width: 1.66667,
    height: 1.66667,
    rx: 0.833333,
    stroke: "url(#paint7_linear_2642_70811)",
    strokeOpacity: 0.1,
    strokeWidth: 0.333333
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_bi_2642_70811)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 14,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#F1F1F1",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 14,
    width: 2,
    height: 2,
    rx: 1,
    fill: "url(#paint8_linear_2642_70811)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.1667,
    y: 14.1667,
    width: 1.66667,
    height: 1.66667,
    rx: 0.833333,
    stroke: "url(#paint9_linear_2642_70811)",
    strokeOpacity: 0.1,
    strokeWidth: 0.333333
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_bi_2642_70811)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 17,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#F1F1F1",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 17,
    width: 2,
    height: 2,
    rx: 1,
    fill: "url(#paint10_linear_2642_70811)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.16667,
    y: 17.1667,
    width: 1.66667,
    height: 1.66667,
    rx: 0.833333,
    stroke: "url(#paint11_linear_2642_70811)",
    strokeOpacity: 0.1,
    strokeWidth: 0.333333
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_bi_2642_70811)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 17,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#F1F1F1",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 17,
    width: 2,
    height: 2,
    rx: 1,
    fill: "url(#paint12_linear_2642_70811)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.1667,
    y: 17.1667,
    width: 1.66667,
    height: 1.66667,
    rx: 0.833333,
    stroke: "url(#paint13_linear_2642_70811)",
    strokeOpacity: 0.1,
    strokeWidth: 0.333333
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_bi_2642_70811)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 17,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#F1F1F1",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 17,
    width: 2,
    height: 2,
    rx: 1,
    fill: "url(#paint14_linear_2642_70811)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.1667,
    y: 17.1667,
    width: 1.66667,
    height: 1.66667,
    rx: 0.833333,
    stroke: "url(#paint15_linear_2642_70811)",
    strokeOpacity: 0.1,
    strokeWidth: 0.333333
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_bi_2642_70811)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 11,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#F1F1F1",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 11,
    width: 2,
    height: 2,
    rx: 1,
    fill: "url(#paint16_linear_2642_70811)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.1667,
    y: 11.1667,
    width: 1.66667,
    height: 1.66667,
    rx: 0.833333,
    stroke: "url(#paint17_linear_2642_70811)",
    strokeOpacity: 0.1,
    strokeWidth: 0.333333
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_bi_2642_70811)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 11,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#F1F1F1",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 11,
    width: 2,
    height: 2,
    rx: 1,
    fill: "url(#paint18_linear_2642_70811)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.1667,
    y: 11.1667,
    width: 1.66667,
    height: 1.66667,
    rx: 0.833333,
    stroke: "url(#paint19_linear_2642_70811)",
    strokeOpacity: 0.1,
    strokeWidth: 0.333333
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bi_2642_70811",
    x: 1,
    y: -1,
    width: 22,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2642_70811"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2642_70811",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2642_70811"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bi_2642_70811",
    x: 1,
    y: 6,
    width: 12,
    height: 12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2642_70811"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2642_70811",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.833333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.66667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2642_70811"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bi_2642_70811",
    x: 1,
    y: 9,
    width: 12,
    height: 12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2642_70811"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2642_70811",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.833333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.66667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2642_70811"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_bi_2642_70811",
    x: 6,
    y: 9,
    width: 12,
    height: 12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2642_70811"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2642_70811",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.833333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.66667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2642_70811"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_bi_2642_70811",
    x: 11,
    y: 9,
    width: 12,
    height: 12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2642_70811"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2642_70811",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.833333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.66667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2642_70811"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_bi_2642_70811",
    x: 1,
    y: 12,
    width: 12,
    height: 12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2642_70811"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2642_70811",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.833333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.66667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2642_70811"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_bi_2642_70811",
    x: 6,
    y: 12,
    width: 12,
    height: 12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2642_70811"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2642_70811",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.833333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.66667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2642_70811"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_bi_2642_70811",
    x: 11,
    y: 12,
    width: 12,
    height: 12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2642_70811"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2642_70811",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.833333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.66667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2642_70811"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_bi_2642_70811",
    x: 6,
    y: 6,
    width: 12,
    height: 12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2642_70811"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2642_70811",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.833333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.66667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2642_70811"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_bi_2642_70811",
    x: 11,
    y: 6,
    width: 12,
    height: 12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2642_70811"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2642_70811",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.833333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.66667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2642_70811"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2642_70811",
    x1: 4,
    y1: 2,
    x2: 23.2676,
    y2: 5.91393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3864FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2642_70811",
    x1: 4.5,
    y1: 2.90909,
    x2: 20,
    y2: 2.90909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EE5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41A9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2642_70811",
    x1: 6,
    y1: 11,
    x2: 8.35594,
    y2: 11.5982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#379FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2642_70811",
    x1: 6.0625,
    y1: 11.0909,
    x2: 8,
    y2: 11.0909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EE5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41A9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2642_70811",
    x1: 6,
    y1: 14,
    x2: 8.35594,
    y2: 14.5982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#379FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2642_70811",
    x1: 6.0625,
    y1: 14.0909,
    x2: 8,
    y2: 14.0909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EE5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41A9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2642_70811",
    x1: 11,
    y1: 14,
    x2: 13.3559,
    y2: 14.5982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#379FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2642_70811",
    x1: 11.0625,
    y1: 14.0909,
    x2: 13,
    y2: 14.0909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EE5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41A9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2642_70811",
    x1: 16,
    y1: 14,
    x2: 18.3559,
    y2: 14.5982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#379FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2642_70811",
    x1: 16.0625,
    y1: 14.0909,
    x2: 18,
    y2: 14.0909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EE5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41A9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2642_70811",
    x1: 6,
    y1: 17,
    x2: 8.35594,
    y2: 17.5982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#379FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2642_70811",
    x1: 6.0625,
    y1: 17.0909,
    x2: 8,
    y2: 17.0909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EE5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41A9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2642_70811",
    x1: 11,
    y1: 17,
    x2: 13.3559,
    y2: 17.5982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#379FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2642_70811",
    x1: 11.0625,
    y1: 17.0909,
    x2: 13,
    y2: 17.0909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EE5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41A9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2642_70811",
    x1: 16,
    y1: 17,
    x2: 18.3559,
    y2: 17.5982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#379FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2642_70811",
    x1: 16.0625,
    y1: 17.0909,
    x2: 18,
    y2: 17.0909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EE5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41A9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2642_70811",
    x1: 11,
    y1: 11,
    x2: 13.3559,
    y2: 11.5982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#379FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2642_70811",
    x1: 11.0625,
    y1: 11.0909,
    x2: 13,
    y2: 11.0909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EE5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41A9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2642_70811",
    x1: 16,
    y1: 11,
    x2: 18.3559,
    y2: 11.5982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#379FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2642_70811",
    x1: 16.0625,
    y1: 11.0909,
    x2: 18,
    y2: 11.0909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EE5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41A9FF"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalculatorIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Calculator-Icon.4ebe2262.svg";
export { ForwardRef as ReactComponent };